import React from 'react'

var EventFormFieldCheckbox = React.createClass({
  render: function() {

    var checkedLink = {
      value: this.props.checked,
      requestChange: function(newValue) {
        this.props.onChange.call(null, { target:{ name: this.props.name, value: newValue }})
      }.bind(this)
    };

    const { onChange, label, name, value, response_options, required } = this.props;
    // console.log(this.props);
    const checkbox_options = response_options.map( (o, i) => {

      if(value.indexOf(o.name) > -1) {
        return [ <div className="row">
              <label><input type="checkbox" key={o.id} name={name} value={o.name} checkedLink={checkedLink}  defaultChecked />&nbsp;{o.label} </label>
            </div> ];
      }
      else {
        return [ <div className="row">
              <label><input type="checkbox" key={o.id} name={name} value={o.name} checkedLink={checkedLink} />&nbsp;{o.label} </label>
            </div> ];
      }
      
    });


    return(

      <div className="form-group">
        <label className="col-lg-2 control-label">{label}{ required ? '*' : undefined }</label>

        <div className="col-lg-10">
          {checkbox_options}
        </div>

      </div>
    );
  }
});

export default EventFormFieldCheckbox;


// WEBPACK FOOTER //
// ./src/components/event_form_field_checkbox.js